// extracted by mini-css-extract-plugin
export default {"logout":"LogoutButton_logout__x1tU8"};